var axios = require('axios');
var moment = require('moment');
var config = require('./config');

require('moment/locale/sv');
moment.locale('sv');

require('bootstrap/scss/bootstrap.scss');
require('./styles.scss');

var stableId = (function (path) {
  if (!path || path === '/') {
    console.error('Missing organisation parameter. Please verify URL.');
  }
  var parts = path.split('/');
  for (var i = parts.length - 1; i >= 0; i--) {
    if (parts[i] && parts[i] !== '') {
      return parts[i];
    }
  }
  return null;
})(window.location.pathname);

function setValue(className, value) {
  const elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++) {
    elements[i].innerText = value;
  }
}

axios.get(config.apiUrl() + '/api/gdpr/' + stableId)
  .then(function(response) {
    var data = response.data;
    setValue('company-name', data.orgName);
    setValue('org-number', data.companyRegNo);
    setValue('contact-name', data.name);
    setValue('contact-email', data.email);
    setValue('contact-phone', data.phone);

    if (data.bookingMaxAge) {
      setValue('booking-max-age', moment.duration(data.bookingMaxAge).humanize());
    }
    if (data.customerLogMaxAge) {
      setValue('customer-log-max-age', moment.duration(data.customerLogMaxAge).humanize());
    }
    if (data.inactiveCustomerMaxAge) {
      setValue('inactive-customer-max-age', moment.duration(data.inactiveCustomerMaxAge).humanize());
    }
  })
  .catch(function() {
    console.error('Could not get info for ' + stableId + '. Please verify URL.');
  });
